import LogRocket from 'logrocket';

import { Concierge } from 'typings';

const CONCIERGE_SETTINGS_KEY = 'conciergeSettings';

export const getPreferences = () => {
  return JSON.parse(localStorage.getItem(CONCIERGE_SETTINGS_KEY) || '{}');
};

export const setPreference = (key: string, value: any) => {
  const userPreferences = getPreferences();
  userPreferences[key] = value;
  localStorage.setItem(CONCIERGE_SETTINGS_KEY, JSON.stringify(userPreferences));
};

export const registerLogRocket = (concierge: Partial<Concierge>) => {
  LogRocket.identify(`${concierge.id}`, {
    name: concierge?.name || '',
    conciergeRoleId: concierge?.conciergeRoleId || '',
    env: process.env.REACT_APP_DOMAIN ?? '',
  });
};
